import React from "react";
import Custombutton from "../../../utils/Custombutton";
import { Link } from "react-router-dom";

const NewsBlogs = () => {
  const customStyle = {
    borderRadius: "35px",

    display: "flex",
    justifyContent: "center",
    alignitems: "center",
    flexGrow: 1,
    flexShrink: 0,
  };
  return (
    <div className="news  ">
      <div className="inner-news  ">
        <div className="container"> <br /><br /><br />
          <div className="row">
            <div className="col-lg-12">
              <div className="d-flex flex-md-nowrap align-items-end justify-content-between flex-wrap">
                <div className="position-relative">
                  <h1>
                    News & <br /> blog
                  </h1>
                  <h2 className="bordered-text">
                    News & <br /> blog
                  </h2><br /><br />
                </div>
                <Link to='https://medium.com/@cosmic_network'>
                  <Custombutton
                    className={
                      "btn-outline gradient-outline gradient-text mt-5 mt-md-0 "
                    }
                    label={"view all"}
                  />
                </Link>
              </div>
            </div>
            {/* <div className="col-lg-12 mt-md-5 mt-3">
              <div className="card-custom card-customs p-0 mt-2 mt-lg-5">
                <div className="row align-items-center">
                  <div className="col-md-6">
                    <img
                      className="w-100 web"
                      src="./assets/images/router.png"
                      alt="external"
                    />
                    <img
                      className="w-100 mobile"
                      src="./assets/images/mobile-router.png"
                      alt="external"
                    />
                    <img src="" alt="" />
                  </div>
                  <div className="col-md-6">
                    <div className="  p-3 p-lg-0">
                      <h3 className="mb-1 mb-lg-3">
                        Cosmic <br /> Router
                      </h3>
                      <p className="mb-1 mb-lg-3">
                        If you see any content below <br />
                        that look like ours, it’s likely <br />
                        to be spam or phishing.
                      </p>
                      <span>0% Taxes Forever</span>
                    </div>
                  </div>
                  <div className="top-ex">
                    <img
                      className="external-grad"
                      src="./assets/images/external.png"
                      alt="external"
                    />
                  </div>
                </div>
              </div>
            </div> */}
            {/* <div className="  col-xl-4 mt-md-5 mt-3">
              <div className="card-custom card-customs p-0  news-textt mt-2 mt-lg-5">
                <div className="row">
                  <div className="  col-lg-12">
                    <img
                      className="w-100"
                      src="./assets/images/node.png"
                      alt="node"
                    />
                  </div>
                  <div className=" col-lg-12">
                    <div className="d-flex align-items-center justify-content-between flex-md-nowrap flex-wrap     ">
                      <div className="" style={{ width: "fit-content" }}>
                        <img
                          className="w-100 web"
                          src="/assets/images/newstext.png"
                          alt="newstext"
                        />
                        <img
                          className="w-100 mobile"
                          src="/assets/images/new-text-mobile.png"
                          alt="newstext"
                        />
                      </div>
                      <p className="p-3 p-lg-3 w-100 ">
                        A Step-by-Step Guide to Minting a Hosted Node on the Cosmic Network.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
            <div className="  col-xl-4  mt-md-5 mt-3">
              <Link to='https://medium.com/@cosmic_network/a-step-by-step-guide-to-minting-a-hosted-node-on-the-cosmic-network-69fa0cee6a4f'>
                <div className="card-custom card-customs p-0  mt-2 mt-lg-5 d-md-block">
                  <img
                    className="w-100"
                    src="./assets/images/blog-1.png"
                    alt="node"
                  />
                </div>
              </Link>
            </div>
            <div className=" col-xl-4  mt-md-5 mt-3">
              <Link to='https://medium.com/@cosmic_network/announcing-the-launch-of-cosmic-networks-decentralized-vpn-32dc01aaac49'>
                <div className="card-custom card-customs p-0  mt-2 mt-lg-5 d-none d-md-block">
                  <img
                    className="w-100"
                    src="./assets/images/blog-2.png"
                    alt="node"
                  />
                </div>
              </Link>
            </div>
            <div className=" col-xl-4  mt-md-5 mt-3">
              <Link to='https://medium.com/@cosmic_network/cosmic-network-relaunch-a-comprehensive-guide-2ccc20e7064f'>

                <div className="card-custom card-customs p-0  mt-2 mt-lg-5 d-none d-md-block">
                  <img
                    className="w-100"
                    src="./assets/images/blog-3.png"
                    alt="node"
                  />
                </div>
              </Link>
            </div>
            {/* <div className="  col-xl-4 mt-md-5 mt-2">
              <div className="d-flex align-items-stretch flex-column h-100 w-100">
                
                <div className="card-custom card-customs flex-grow-1 p-0 mt-1 mt-lg-5 h-100">
                  <img
                    className="w-100 h-100"
                    src="./assets/images/brand.png"
                    alt="node"
                  />
                </div>

             
                <Link to="/blogs" className="h-100">
                  <Custombutton
                    className="btn-outline gradient-outline gradient-text mt-4 mt-xxl-4 w-100 h-100"
                    style={customStyle}
                    label={"view all"}
                  />
                </Link>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </div >
  );
};

export default NewsBlogs;
